<template>
    <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-card-body uk-width-1-1@m mt-5">
            <div class=" uk-width-1-1@m">
                <h2 class="uk-modal-title">Mise à jour de retour de livraison</h2> <br>
                <form @submit.prevent="onUpdateForm">
                    <fieldset class="uk-fieldset">
                        <!-- <div class="uk-margin">
                            <label for="nature_coli"> <b>Naure du coli :</b> </label>
                            <input class="uk-input" name="nature_coli" id="nature_coli" type="text" v-model="retour.nature_coli" placeholder="Nature du coli" required>
                        </div>
                        <div class="uk-margin">
                            <label for="Valeur_coli"> <b>Valeur du coli :</b> </label>
                            <input class="uk-input" name="Valeur_coli" id="Valeur_coli" type="number" v-model="retour.valeur_coli" placeholder="Valeur du coli" required>
                        </div> -->
                        <div class="uk-margin">
                            <label for="nom_boutique"> <b>Nom de la boutique :</b> </label>
                            <input class="uk-input" name="nom_boutique" id="nom_boutique" type="text" v-model="retour.nom_boutique" placeholder="Nom de la boutique" required>
                        </div>
                        <div class="uk-margin">
                            <label for="lieu_livraison"> <b>Lieu de livraison :</b> </label>
                            <input class="uk-input" name="lieu_livraison" id="lieu_livraison" type="text" v-model="retour.lieu_livraison" placeholder="Lieu de la livraison" required>
                        </div>
                        <div class="uk-margin">
                            <label for="num_dest"> <b>Numéro du destinataire :</b> </label>
                            <input class="uk-input" name="num_dest" id="num_dest" type="text" v-model="retour.phone_destinataire" placeholder="N° Tel Destinataire" required>
                        </div>
                        <div class="uk-margin">
                            <label for="motif"> <b>Motif du retour :</b> </label>
                            <textarea class="uk-textarea" name="motif" id="motif" v-model="retour.motif_retour" rows="5" placeholder="Motif du retour"></textarea>
                        </div>
                        <div class="uk-margin uk-flex uk-child-width-auto uk-grid">
                            <label><b>TYPE DE RETOUR :</b></label>
                            <div class="uk-flex">
                                <div class="radios">
                                    <label><input class="uk-radio" type="radio" name="categorie" :value="'Relance'" v-model="retour.relance_retour" checked required>RELANCE</label>
                                </div>
                                <div>
                                    <label><input class="uk-radio" type="radio" name="categorie" :value="'Retour'" v-model="retour.relance_retour" checked required>RETOUR</label>
                                </div>
                            </div>
                        </div>
                        <div class="uk-margin">
                            <label for="date"> <b>Date de relance :</b> </label>
                            <input class="uk-input" name="date" id="date" type="date" v-model="retour.date_relance" placeholder="date de retour" required>
                        </div>
                        <div class="uk-margin">
                            <label class="uk-form-label" for="form-stacked-select"> <b> Satut de relance :</b> </label>
                            <div class="uk-form-controls">
                                <select class="uk-select" v-model="retour.statut_retour" id="form-stacked-select">
                                    <option :value="'En attente'">EN ATTENTE</option>
                                    <option :value="'Relancé'">RELANCÉ</option>
                                    <option :value="'Retourné'">RETOURNÉ</option>
                                    <option :value="'Livré'">LIVRÉ</option>
                                    <option :value="'Annulé'">ANNULÉ</option>
                                </select>
                            </div>
                        </div>
                    </fieldset>
                    <div class="d-flex justify-content-center">
                            <button class="btn-round my-1 border-0 px-4 uk-button uk-button-primary" type="submit" style=" color:#fff;  font-size:1em !important; ">Valider</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import { db, dbstore, auth } from '../../main';
    import Swal from "sweetalert2";
    export default {
    data(){
        return{
            retour: {},
        }
    },
    created () {
        let dbRefStore = dbstore.collection('livraison_retour').doc(this.$route.params.id);
        dbRefStore.get().then(doc => {
            if(doc.exists){
                this.retour = doc.data();
            }
        })
    },
    methods: {
        onUpdateForm(event) {
            event.preventDefault();
            dbstore.collection('livraison_retour').doc(this.$route.params.id)
            .update(this.retour).then(doc => {
                console.log("Mise à jour effectuée");
                this.$router.push('/admin/livraison/retours');
                Swal.fire({
                    title: 'Mise à jour effectuée',
                    text: 'Votre retour de livraison a été mis à jour avec succès',
                    type: 'success',
                    confirmButtonText: 'Ok'
                })
            }).catch(error => {
                console.log(error);
            })
        }
    }
}
</script>
<style>

.uk-textarea {
   background-color: rgba(146, 143, 143, 0.174);
   border-radius: 10px;
}

.radios {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.uk-radio {
  margin-right: 10px;
   margin-left: 10px;
}

</style>